import styled from "styled-components";

import BackgroundNextEvent from "../../../assets/comandatuba/background.png";
import BackgroundNextEventMobile from "../../../assets/comandatuba/banner.png";

export const Container = styled.section`
  width: 100%;
  display: flex;
  min-height: 481px;
  margin-bottom: 47px;
  background-image: url(${BackgroundNextEvent});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;

  @media (max-width: 1200px) {
    background-image: url(${BackgroundNextEventMobile});
    background-position: calc(100% + 200px);
  }

  @media (max-width: 830px) {
    background-image: none;
  }
`;

export const Content = styled.div`
  margin: 0 8%;

  @media (max-width: 830px) {
    margin: 0 5%;
  }
`;

export const NextEventOne = styled.div`
  height: 100%;
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
  width: 100%;

  @media (max-width: 830px) {
    width: 100%;
    align-items: center;
  }

  .next_event {
    color: #292623;

    @media (max-width: 830px) {
      margin-bottom: 35px;
      justify-content: center;
    }
  }
`;

export const Banner = styled.img`
  display: none;

  @media (max-width: 830px) {
    display: flex;
    width: 100%;
    height: auto;
  }
`;

export const NextEventTwo = styled.div`
  width: 50%;
  display: flex;
  align-items: center;

  @media (max-width: 830px) {
    width: 100%;
    flex-direction: column;
  }
`;

export const DateEdition = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 830px) {
    flex-direction: column-reverse;
    text-align: center;
    margin-bottom: 41px;
  }
`;

export const Month = styled.span`
  font-family: "GothamPro", sans-serif;
  font-weight: bold;
  color: #292623;
  font-size: 34px;

  @media (max-width: 830px) {
    font-size: 20px;
  }
`;

export const Date = styled.div`
  font-family: "GothamPro", sans-serif;
  color: #292623;
  font-weight: 600;
  font-size: 48px;

  span {
    color: #f3b000;
  }

  @media (max-width: 830px) {
    font-size: 30px;
  }
`;

export const Logo = styled.img`
  width: 170px;
  height: 36px;
`;

export const ContainerButton = styled.div`
  width: 100%;
  max-width: 356px;
`;

export const ContainerButtonTwo = styled.div`
  display: none;
  width: 100%;
  max-width: 356px;

  @media (max-width: 830px) {
    display: flex;
  }
`;
